export default __webpack_public_path__ + "locales/pt-BR/SalesDepartmentRequestDialog.json?hash=d9b3196f3567b4509b5998fa95ad4864";